import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { CrudGenericsService } from '../common/crud-generics';
import { Environment, Aziende } from '../../models/-index';

@Injectable()
export class AziendeService extends CrudGenericsService<Aziende, number> {
  // private base:string;

  constructor(protected http: HttpClient, @Inject('ENV') env: Environment) {
    super(http, `${env.apiUrl}/api/Aziende`);
    //  this.base = `${env.apiUrl}/api/Aziende/`;
  }
}
